// Main page content
const main = {
  // 頁面標題和描述
  pageTitle: "地址補全",
  pageDescription: "支持開頭和末尾的模糊匹配，提供數據越全查找越精準",

  // 表單標籤
  addressStartLabel: "地址開頭",
  addressEndLabel: "地址末尾",

  // 表單佔位符
  addressStartPlaceholder: "請輸入至少4個地址開頭字符（必填）",
  addressEndPlaceholder: "請輸入地址末尾字符（非必填)",

  // 按鈕
  queryButton: "查詢",
  resetButton: "重置",

  // 狀態提示
  loadingText: "拼命加載中",
  noDataText: "暫無數據",
  emptyPrompt: "請輸入地址的開頭或末尾進行查詢",

  // 結果展示
  addressLabel: "地址",

  // 驗證消息
  addressStartRequired: "請輸入地址開頭",

  // 通知消息
  copySuccess: "複製成功",
  notificationTitle: "提示",
  noResultsFound: "很抱歉，查詢結果中沒有找到相關數據",
};

// Hash completion page content
const hashCompletion = {
  // 頁面標題和描述
  hashPageTitle: "哈希補全",
  hashPageDescription: "支持開頭和末尾的模糊匹配，提供數據越全查找越精準",

  // 表單標籤
  hashStartLabel: "哈希開頭",
  hashEndLabel: "哈希末尾",

  // 表單佔位符
  hashStartPlaceholder: "請輸入哈希開頭字符（必填）",
  hashEndPlaceholder: "請輸入哈希末尾字符（非必填）",

  // 按鈕
  hashQueryButton: "查詢",
  hashResetButton: "重置",

  // 狀態提示
  hashLoadingText: "拼命加載中",
  hashNoDataText: "暫無數據",
  hashEmptyPrompt: "請輸入哈希的開頭或末尾進行查詢",

  // 結果展示
  hashLabel: "哈希",

  // 驗證消息
  hashStartRequired: "請輸入哈希開頭",

  // 通知消息
  hashCopySuccess: "複製成功",
  hashNotificationTitle: "提示",
  hashNoResultsFound: "很抱歉，查詢結果中沒有找到相關數據",

  // 地址流入彈窗
  inflowDialog: {
    title: "地址流入交易概況",
    totalData: "共計",
    dataUnit: "條數據",
    download: "下載",
    loadingText: "拼命加載中",
    selectAddressFirst: "請先選擇地址",
    queryInflow: "查詢地址流入",
    dataLabel: "數據",
    dataCount: "條",
    tagLabel: "標籤",
    blockchainLabel: "所屬鏈",
    addressLabel: "地址",
    defaultHeaders: {
      address: "地址",
      tokenTotalInflow: "總流入(USDT)",
      mainCoinTotalInflow: "總流入(主幣)",
    },
  },
};

export default {
  ...main,
  ...hashCompletion,

  // Sub-modules
};
